import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Container } from '@adobe/cq-react-editable-components';
import parse from 'html-react-parser';
import { apiUrls } from '../../../../constants/apiUrl.js';
import { FWAContainer } from '../../../common/FWAContainer';
import { Row, Col } from '../../../common/Grid';
import './deviceSetup.css';
import MiniCart from '../../../common/MiniCart/redesign';
import { updateEventInfo, eventDispatcher } from '../../../common/Tagging/index';
import {
  isMobile,
  getAPPID,
  setCookie,
  getPrefetch,
  isTablet,
  isDesktopResolution,
  getSession,
  renderHTML,
  getUrlName,
  getFlowType,
  saveAllProcessSteps,
  enablePegaProcessSteps,
  isJointTransactionFlow,
  getIntendType,
  isExpressCheckout,
  // setSession,
} from '../../../common/Helpers/index';

import { checkPlanReferenceData, getProductRefData } from '../../../../utils/plansReference';
import { saveItemToStore, getItemFromStore } from '../../../../utils/sessionStorage';
import Notification from '../../../common/Notification/redesign/index';
import { lazyWithPreload } from '../../../common/Helpers/lazyWithPrefetch';
import { checkCartidAndLQResponse, redirectToHomePage } from '../../../common/Helpers/commonLog';
import logger from '../../../common/ErrorBoundary/logger_new';
import { SETUP_CHOICE, USER_INFO, SELFSETUP_CONTINUE_CLICK, PROFSETUP_CONTINUE_CLICK } from '../../../../services/metricsService';
import { Margin } from '../../../common/styles';
import { goToProcessStep, redirectTo } from '../../../../redirection';
import Button from '../../../common/Button';
import { commonErrors } from '../../../common/Helpers/constants';
import { getChannelId } from '../../../../services/HttpService';
import { store } from '../../../../configureStore';
import { callPerformanceMeasure } from '../../../common/Helpers/performanceMeasure';
import { SETUP_OPTION_PROF, SETUP_OPTION_SELF } from '../constants.js';
import { isAppointmentSetupEnabled } from '../../../common/Helpers/sessionUtils.js';
// import StickyCart from '../../../NextGen/OrderSummary/StickyCart.js';
import DesktopCart from '../../../NextGen/OrderSummary/DesktopCart';

class DeviceSetup extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('deviceSetup');
    setCookie('selectedSetupOption', SETUP_OPTION_SELF);
    this.props.hideNotificationBar();
    window.addEventListener('DOMContentLoaded', () => {});
    this.handleLoad = this.handleLoad.bind(this);
    checkPlanReferenceData(props.plansReferenceData);
    this.noDatesAvailableCheck = false;
  }

  componentDidMount() {
    window.addEventListener('load', this.handleLoad);
    document.title = 'Set up options';
    const allProcessStep = saveAllProcessSteps();
    if (this.props.homePlanState && this.props.homePlanState.plansJson) {
      return;
    }
    this.props.showCart(false);
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.performPreFetch();
      }
    };
    if (isMobile() && window.vzFlags?.miniCartApi) {
      this.props.getMiniCartAPI();
    } else {
      this.props.getCartDataFromApi('setup');
    }
    const expresscart = getItemFromStore('isResumeFlow');
    if (expresscart === 'true') {
      updateEventInfo('event86');
      saveItemToStore('isResumeFlow', false);
    }
    if (allProcessStep) {
      store.dispatch({ type: 'ALL_PROCESS_STEP', value: allProcessStep });
    }
    store.dispatch({ type: 'DEVICE_SETUP_ERROR', errorSetup: false, errorMessage: null });
    store.dispatch({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
    store.dispatch({ type: 'UPDATED_SETUP_PROCESSSTEP', value: false });
  }

  componentDidUpdate() {
    // added to share the session id to pdm/nse api call
    if (this.props.channelSession && !this.state?.apiCalled) {
      const isLoggedIn = getAPPID() === 'AAL';

      const data = {
        pageName: 'setup',
      };
      if (!isLoggedIn) {
        this.props.updatePdc(data);
        this.setState({ apiCalled: true });
      }
    }
    // if (this.props.apiLoaded) {
    //   callPerformanceMeasure();
    // }
    if (document.readyState === 'complete') {
      callPerformanceMeasure();
    }
    if (!this.state.invokeTagging && this.props.cartDetails?.apiStatus === 'COMPLETED') {
      this.props.invokeTaggingAPI();
      this.setState({ invokeTagging: true });
    }
  }

  handleLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
  }

  performPreFetch = () => {
    if (!getPrefetch()) {
      return;
    }
    const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../Cart/redesign/index'));
    if (typeof ComponentToPreload?.preload === 'function') ComponentToPreload.preload();
  };

  // handle continue submit for professional setup
  handleContinueSubmit = (selectedSetupOption) => {
    // let setUpOption = selectedSetupOption;
    // if (isExpressCheckout()) {
    //   setUpOption = this.props?.deviceSetUpState?.selectedOption;
    // }
    const payloadData = this.props?.appointmentScheduleState;
    if (!payloadData?.appointmentScheduleResponse?.output?.apptAvailableDays?.length || payloadData?.appointmentScheduleResponse?.error) {
      this.noDatesAvailableCheck = true;
    }
    if (payloadData && selectedSetupOption === SETUP_OPTION_PROF && payloadData?.isValidProSetupData && isAppointmentSetupEnabled()) {
      const startTime = payloadData?.selectedSlotR?.startTime?.split(':')[0]?.replace(':', '');
      const endTime = payloadData?.selectedSlotR?.endTime?.split(':')[0]?.replace(':', '');
      let slotLength = endTime - startTime;
      if (slotLength && slotLength < 0) {
        slotLength *= -1;
        slotLength = 12 - slotLength;
      }
      let homephone = '';
      let emailaddress = '';

      if (payloadData?.reminderTypeR === 'Call' || payloadData?.reminderTypeR === 'SMS') {
        homephone = payloadData?.phoneNumberR;
      }

      if (payloadData?.reminderTypeR === 'Email') {
        emailaddress = payloadData?.emailIdR;
      }

      let availableDay = payloadData?.selectedSlotR?.availableDay;
      let availableType = payloadData?.selectedSlotR?.availableType;
      if (!availableDay) {
        availableDay = '3';
      }
      if (!availableType) {
        availableType = '0';
      }

      const payloadRequestData = {
        cartInfo: {
          correlationId: '',
          accountNumber: '',
          cartCreator: '',
          processingMTN: 'newLine1',
          processStep: '',
          processAction: 'UpdateScheduleAppointment',
          intendType: `${getIntendType()}`,
        },
        data: {
          cartLineMtn: 'newLine1',
          apptInfo: {
            homePhone: homephone,
            primaryPhoneType: 'Home',
            preferredContactType: payloadData?.reminderTypeR,
            emailAddress: emailaddress,
            firstName: this.props?.cartDetails?.primaryUserInfo?.firstName,
            lastName: this.props?.cartDetails?.primaryUserInfo?.lastName,
            installationFloor: '',
            languagePref: 'E',
            installApptSelectedDate: {
              availableDate: payloadData?.dateObj?.selectedDateR,
              availableDay,
              availableType,
              serviceProviderAccount: payloadData?.selectedSlotR?.serviceProviderAccount,
              serviceProviderName: payloadData?.selectedSlotR?.serviceProviderName,
              slotLength,
              slotStartTime: payloadData?.selectedSlotR?.slotStartTime,
            },
            customerInstructions: payloadData?.specInstR,
            eventCorrelationId: '',
          },
        },
      };
      this.handleSubmit(selectedSetupOption, payloadRequestData);
      // this.props.postProInstallationDeviceSetup(payloadRequestData);
    } else {
      this.handleSubmit(selectedSetupOption);
    }
  };

  handleSubmit = (selectedSetupOption, payloadRequestData = {}) => {
    const selValue = this.props?.deviceSetUpState?.selectedOption;
    const cartValue = this.props?.cartDetails?.cartDetailsJson?.dueTodayList?.[0]?.installationType || '';
    const changedSetUp = cartValue && selValue && cartValue?.toLowerCase()?.toString()?.includes(selValue?.toLowerCase()?.toString());
    if (selectedSetupOption === SETUP_OPTION_SELF) {
      this.props.updateProcessStepSetup(changedSetUp);
    }
    if (selValue !== '') {
      if (cartValue?.toLowerCase()?.toString()?.includes(selValue?.toLowerCase()?.toString())) {
        if (enablePegaProcessSteps() && selectedSetupOption === SETUP_OPTION_PROF) {
          this.props.updateProcessStepSetup(changedSetUp);
        }
        this.redirectToCart(selectedSetupOption);
      } else {
        const selectedType = {};
        const bundeType = this.getBundleName(selectedSetupOption);
        selectedType.bundleInstallType = bundeType;
        if (selValue === SETUP_OPTION_SELF) {
          selectedType.depletionType = 'F';
        } else {
          selectedType.depletionType = 'O';
          const planInfo = getProductRefData('willowOneTimeChargesSection', 'willowOneTimeChargesSection', this.props.plansReferenceData);
          if (planInfo && selValue !== SETUP_OPTION_SELF) {
            const data = {
              name: `${planInfo[0]?.setupName}  ${planInfo[0]?.setupCharges}`,
              category: 'deviceSetup',
              discount: '',
              line: '',
              merchCat: null,
              qty: 1,
              sku: `${planInfo[0]?.spoid ? planInfo[0]?.spoid : ''}`,
              shared: 'N',
              nonRecurringPrice: `${planInfo[0]?.setupCharges}`,
              recurringPrice: '',
            };
            const omniData = { current: [data], page: 'setup' };
            eventDispatcher('addToCart', omniData);
            updateEventInfo('scAdd');
          }
        }
        // const editSetupClicked = getSession('isEditSetupOption');
        const payLoadObj = {
          payloadRequestData,
          noDatesAvailableCheck: this.noDatesAvailableCheck,
        };
        // editSetupClicked,

        this.props.postAddToCart(selectedType, 'deviceSetup', [], '', '', payLoadObj);
        // setSession('isEditSetupOption', '');
        updateEventInfo('scAdd');
      }
    } else {
      this.redirectToCart(selectedSetupOption);
      // setSession('isEditSetupOption', '');
    }
  };

  getBundleName = (option) => {
    let val = '';
    const LQResponseData = JSON.parse(getSession('LQResponse'));
    if (LQResponseData && LQResponseData.output && LQResponseData.output.bundleDetails) {
      LQResponseData.output.bundleDetails.map((item) => {
        if ((option === SETUP_OPTION_PROF && item.type === 'p') || (option === SETUP_OPTION_SELF && item.type === 's')) {
          val = item.bundleName;
        }
        return val;
      });
    } else if (this.props.eligible5GHomeBundle) {
      this.props.eligible5GHomeBundle.map((item) => {
        if (
          (option === SETUP_OPTION_PROF && item.bundleName.includes('Prof')) ||
          (option === SETUP_OPTION_SELF && item.bundleName.includes('Self'))
        ) {
          val = item.bundleName;
        }
        return val;
      });
    }
    return val;
  };

  redirectToCart = (selectedSetupOption) => {
    const planInfo = getProductRefData('willowOneTimeChargesSection', 'willowOneTimeChargesSection', this.props.plansReferenceData);
    if (planInfo && selectedSetupOption === SETUP_OPTION_PROF) {
      console.log(planInfo);
      const data = {
        name: `${planInfo[0]?.setupName}  ${planInfo[0]?.setupCharges}`,
        category: 'deviceSetup',
        discount: '',
        line: '',
        merchCat: null,
        qty: 1,
        sku: `${planInfo[0]?.spoid ? planInfo[0]?.spoid : ''}`,
        shared: 'N',
        nonRecurringPrice: `${planInfo[0]?.setupCharges}`,
        recurringPrice: '',
      };
      const omniData = { current: [data], page: 'setup' };
      eventDispatcher('addToCart', omniData);
      updateEventInfo('scAdd');
    }

    const redirectCovid = this.props.currentView.ProCovid;
    const selectedClickMessage = selectedSetupOption === SETUP_OPTION_PROF ? PROFSETUP_CONTINUE_CLICK : SELFSETUP_CONTINUE_CLICK;
    const redirection = isExpressCheckout()
      ? this.props.currentView?.ExpressCheckout
      : selectedSetupOption === SETUP_OPTION_PROF
        ? redirectCovid
        : this.props.currentView.SELF;
    logger({
      message: selectedClickMessage,
      eventType: 'INFO',
      subHeaderMessage: SETUP_CHOICE,
      messageType: USER_INFO,
      json: true,
    });
    if (!enablePegaProcessSteps()) {
      if (isJointTransactionFlow() && redirection?.nextViewPage === 'cart.html') {
        window.location.href = `${apiUrls().redirectNextgenCart}`;
      } else {
        goToProcessStep(redirection, this.props.history);
      }
    }
  };

  render() {
    // const type = viewport();
    // const flowType = getFlowType();
    const setUpComponents = this.childComponents.filter(
      (item) => !(item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0),
    );
    const miniCartComponents = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    const isError = this.props.setupError;
    const setUppageError = this.props.deviceSetupError;
    if (enablePegaProcessSteps() && this.props.updateSetupProcessStep && this.props.nextProcessStep) {
      store.dispatch({ type: 'UPDATED_SETUP_PROCESSSTEP', value: false });
      if (isJointTransactionFlow() && this.props.nextProcessStep === '/nextgen/expresscart.html') {
        window.location.href = `${apiUrls().redirectNextgenCart}`;
      } else if (isExpressCheckout()) {
        goToProcessStep(this.props.currentView?.ExpressCheckout, this.props.history);
      } else {
        redirectTo(this.props.nextProcessStep, this.props.history);
      }
    }

    const notificationProps = {
      renderIf: false,
      title: '',
      type: 'warning',
      serviceInfo: '',
      subtitle: '',
    };
    if (!this.props.setupInvalidError && (this.props.setupShowError || this.props.cartDetails?.cartError)) {
      notificationProps.renderIf = true;
      notificationProps.title = renderHTML(this.props.setupNtfyMsg || this.props.cartDetails?.cartNtfyMsg || commonErrors?.defaultMessage);
      notificationProps.serviceInfo = this.props.deviceSetupServiceInfo;
    } else if ((isError || setUppageError) && !this.props.setupInvalidError) {
      notificationProps.renderIf = (isError || setUppageError) && !this.props.setupInvalidError;
      notificationProps.title = this.props.notifyMessage || (commonErrors && commonErrors.defaultMessage);
      notificationProps.serviceInfo = this.props.deviceSetupServiceInfo;
    } else if (this.props.setupInvalidError) {
      notificationProps.renderIf = this.props.setupInvalidError;
      notificationProps.title = parse(commonErrors?.transactionExpired || '');
      notificationProps.serviceInfo = '';
    }
    const link = document.getElementById('transactionExpiryLink');
    if (link) {
      link.addEventListener('click', redirectToHomePage);
    }

    return (
      <div className={isMobile() ? 'deviceSetupMainWrapper buttonSpacing' : 'deviceSetupMainWrapper'}>
        <Notification {...notificationProps} />
        <FWAContainer topBufferAuto enableLiveSupport title={this.props.title}>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }}>
              {setUpComponents}
              <Col colSizes={{ mobile: 12, tablet: 9, desktop: 8 }} className={isTablet() ? 'leftPad20' : ''}>
                {!isDesktopResolution() && (
                  <Button
                    className={isMobile() ? 'marginBottom20 marginTop40' : 'marginTop40'}
                    analyticstrack="5G-NextSetupStep"
                    data-track="true"
                    onClick={() => this.handleContinueSubmit(this.props.selectedSetup)}
                    size="large"
                    width={isMobile() ? '100%' : '150px'}
                    primary
                  >
                    Continue
                  </Button>
                )}
              </Col>
            </Col>
            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}>
            {/* {!isDesktopResolution() && isExpressCheckout() && <StickyCart btnName="Review Order" callBtnMethod={this.handleContinueSubmit} />} */}
            {isExpressCheckout() && window.innerWidth > '768' && <DesktopCart/>}
              {!isExpressCheckout() && window.innerWidth > '768' && <MiniCart miniCartComponents={miniCartComponents} showOnlyForDesktopView topMarginStyle={88} />}
              {this.props.selectedSetup
                ? isDesktopResolution() && (
                    <Margin top={isMobile() ? '32px' : isTablet() ? '50px' : '20px'} bottom={isMobile() ? '40px' : ''}>
                      <Button
                        primary
                        size="large"
                        type="button"
                        analyticstrack="5G-NextSetupStep"
                        onClick={() => this.handleContinueSubmit(this.props.selectedSetup)}
                        disabled={this.props?.deviceSetUpState?.continueButtonStatus || false}
                        width={isTablet() && !isDesktopResolution() ? '150px' : '100%'}
                        data-analyticstrack={`{"type": "data",  "name": "5G-NextSetupStep", "data": {"txn": {"installOptions":${this.props.selectedSetup}}}}`}
                      >
                        Continue
                      </Button>
                    </Margin>
                  )
                : ''}

              {/* </Col>
              </Row> */}
            </Col>
          </Row>
        </FWAContainer>
      </div>
    );
  }
}
export default withRouter(DeviceSetup);

DeviceSetup.propTypes = {
  pageName: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
};
